/**
 * Iter 641 — "Instant Pay feel": full-screen overlay shown the moment Pay is
 * tapped, while the backend creates the Stripe checkout page (~0.8 s).
 * Pulsing lock + progress dots so the wait reads as "working", not frozen.
 * Stays visible through the redirect hop to checkout.stripe.com.
 */
import React from "react";

export default function PayOpeningOverlay({ visible }) {
  if (!visible) return null;
  return (
    <div
      data-testid="cust-pay-opening"
      className="fixed inset-0 z-[70] flex flex-col items-center justify-center bg-slate-900/85 px-8 text-center"
      style={{ animation: "cpoFade 120ms ease-out" }}
    >
      <div
        className="w-[88px] h-[88px] rounded-full grid place-items-center border-2"
        style={{
          backgroundColor: "rgba(255,255,255,0.12)",
          borderColor: "rgba(255,255,255,0.35)",
          animation: "cpoPulse 1.04s ease-in-out infinite",
        }}
      >
        <span className="text-[40px] leading-none">🔒</span>
      </div>
      <div className="mt-5 font-display text-lg font-black text-white">Opening secure payment…</div>
      <div className="mt-3.5 flex gap-2">
        {[0, 160, 320].map((delay) => (
          <span
            key={delay}
            className="w-2 h-2 rounded-full bg-white"
            style={{ animation: `cpoDot 640ms ease-in-out ${delay}ms infinite` }}
          />
        ))}
      </div>
      <p className="mt-4 text-xs text-white/75 leading-relaxed">
        Card · Apple Pay · Google Pay
        <br />
        Secured by Stripe — your card details never touch AllSale.
      </p>
      <style>{`
        @keyframes cpoFade { from { opacity: 0; } to { opacity: 1; } }
        @keyframes cpoPulse { 0%,100% { transform: scale(1); } 50% { transform: scale(1.12); } }
        @keyframes cpoDot { 0%,100% { opacity: .25; } 50% { opacity: 1; } }
      `}</style>
    </div>
  );
}
